import { isMobile } from 'react-device-detect';

export default {
    coverages: {
        '1019': {
            name: 'Bas',
            color: 'yellow'
        },
        '1018': {
            name: 'Lagom',
            color: 'light-blue'
        },
        '1020': {
            name: 'Plus',
            color: 'blue'
        }
    },
    coveragesDetails: [
        {
            coverageDesc: `${
                isMobile ? 'Sjukvårds-<br/>rådgivning' : 'Sjukvårdsrådgivning'
            } och vårdplanering - öppen vård`,
            coverageSubDesc:
                'Du får tillgång till Gjensidiges egen vårdplanering som ger rådgivning och bokar läkarbesök, specialistvård och operation/behandling hos privata vårdgivare inom vårt nätverk.',
            '1019': ' ',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: `${
                isMobile ? 'Sjukvårds-<br/>rådgivning' : 'Sjukvårdsrådgivning'
            } och vårdplanering - sluten vård`,
            coverageSubDesc:
                'Gjensidiges egen vårdplanering bokar operationsförberedande undersökning, operation och sjukhusvård.',
            '1019': 'V',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Vårdcoach',
            coverageSubDesc:
                'Du får en personlig kontaktperson/vårdcoach i upp till 2 månader i samband med operation.',
            '1019': 'V',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Privat sjukhusvård vid operation',
            coverageSubDesc:
                'Vi ersätter kostnader för operationsförberedande undersökningar, operation och sjukhusvård hos vårdgivare inom vårt nätverk.',
            '1019': 'V',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: `${
                isMobile ? 'Tandvårds-<br/>kostnader' : 'Tandvårdskostnader'
            } på grund av sjukdom`,
            coverageSubDesc:
                'Om kroppslig sjukdom eller användning av mediciner har orsakat väsentliga tandskador kan du få ersättning för tandvårdskostnader, mellan 10 000 och 40 000 kr/ skadefall beroende på vilken försäkring du har.',
            '1019': 'upp till 10 000 kr',
            '1018': 'upp till 25 000 kr',
            '1020': 'upp till 40 000 kr'
        },
        {
            coverageDesc: 'Eftervård och rehabilitering',
            coverageSubDesc:
                'Försäkringen betalar dina kostnader för medicinsk eftervård och rehabilitering i samband med operation eller sjukhusvård. Sjukvårdsförsäkring Bas ersätter rehabilitering i upp till 21 dagar, Lagom upp till 60 dagar och Plus upp till 120 dagar i följd.',
            '1019': '21 dagar',
            '1018': '60 dagar',
            '1020': '120 dagar'
        },
        {
            coverageDesc: 'Second och Third Opinion',
            coverageSubDesc:
                'Om du diagnostiserats med en livshotande sjukdom, råkat ut för ett livshotande olycksfall eller står inför en riskfylld behandling, ersätter vi kostnader för en ny medicinsk bedömning av en andra specialistläkare. Om denne efter ny bedömning (second opinion) har annan uppfattning om vilken behandling som är lämpligast, erbjuds bedömning av en tredje specialistläkare.',
            '1019': 'V',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Kristerapi vid akut psykisk kris och krisreaktion',
            coverageSubDesc:
                'Om du råkar ut för överfall, rån, våldtäkt, eller blir allvarligt sjuk kan du få ersättning för behandling (upp till 10 ggr) hos psykolog/kristerapeut. Gäller även vid nära anhörigs död.',
            '1019': 'V',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Resor och logi',
            coverageSubDesc:
                'Du får ersättning för rese- och logikostnader i samband med ersättningsbar operation och sjukhusvård samt nödvändig utredning. För att få ersättning måste avståndet mellan behandlingsplats och hem vara minst 10 mil enkel resa. Logi ersätts med upp till 1 500 kr/natt.',
            '1019': 'V',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Privat specialistvård',
            coverageSubDesc:
                'Du får ersättning för medicinsk utredning och behandling av specialistläkare hos privata vårdgivare.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Cancervård - efter remiss',
            coverageSubDesc:
                'Du kan få ersättning för medicinsk nödvändig undersökning eller behandling av cancersjukdomar på privat sjukhus eller annat sjukhus som är specialiserat inom cancervård. Bedömer läkare att det är nödvändigt kan du även få vård inom Norden och i Tyskland.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Psykolog eller Psykoterapeut',
            coverageSubDesc:
                'Du får ersättning för behandling hos psykolog/psykoterapeut efter remiss. Upp till 10 behandlingstillfällen per skada ersätts.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Röntgen och provtagningar',
            coverageSubDesc:
                'Försäkringen ersätter nödvändiga och skäliga kostnader för röntgen, MR (bilddiagnostik) och ytterligare provtagning.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Fysioterapi, Naprapat, Kiropraktor',
            coverageSubDesc:
                'Försäkringen ersätter nödvändiga och skäliga kostnader i samband med diagnostisering och behandling av led-, muskel-, och skelettbesvär. Du får behandling hos till exempel fysioterapeut, naprapat eller kiropraktor efter remiss, upp till 10 behandlingstillfällen/skada.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: `Hemhjälp efter operation/${
                isMobile ? '<br/>' : ''
            }Familjeservice`,
            coverageSubDesc:
                'Du kan få hemhjälp eller familjeservice efter operation i sluten vård, i upp till 10 timmar om du har Sjukvårdsförsäkring Lagom. Har du Plus kan hemhjälp beviljas med upp till 20 timmar.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Hjälpmedel',
            coverageSubDesc:
                'Vi betalar kostnader för tillfälliga medicinska hjälpmedel som ordinerats av läkare. För skoinlägg ersätter vi upp till 1 500 kr, för övriga hjälpmedel upp till 40 000 kr.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'E-vårdstjänsten KRY',
            coverageSubDesc:
                'E-vårdstjänsten KRY gör det möjligt att kostnadsfritt träffa legitimerade läkare, psykologer och sjuksköterskor i mobilen. Appen hämtas i AppStore eller med Google Play, du loggar in med BankID och KRY kan se att du har en giltig försäkring hos oss.',
            '1019': '',
            '1018': 'V',
            '1020': 'V'
        },
        {
            coverageDesc: 'Receptbelagda läkemedel',
            coverageSubDesc:
                'Ersättning för receptbelagda offentligt subventionerade läkemedel upp till gällande högkostnadsskydd. Gäller endast i samband med ersättningsbar operation och sjukhusvård, i upp till 1 månad efter utskrivningsdagen.',
            '1019': '',
            '1018': '',
            '1020': 'V'
        },
        {
            coverageDesc: 'Akupunktur, Osteopat, Dietist',
            coverageSubDesc:
                'Du får behandling hos akupunktör, osteopat eller dietist efter remiss. Vi ersätter per händelse upp till 5 behandlingstillfällen hos akupunktör, upp till 15 behandlingstillfällen hos osteopat och upp till 5 besök eller behandlingstillfällen hos dietist.',
            '1019': '',
            '1018': '',
            '1020': 'V'
        }
    ]
};
